import { Component, inject, signal, effect, computed, ElementRef } from '@angular/core';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { I18nService } from '../../services/i18n.service';
import { GLOBAL_CONSTANT } from '../../constants/global.constant';
import { Icons } from '../../enums/icons.enum';

@Component({
  selector: 'app-scroll-to-top',
  imports: [NzIconModule],
  templateUrl: './scrollToTop.html',
  styleUrls: ['./scrollToTop.scss'],
})
export class ScrollToTopComponent {
  // Inject services
  public i18n = inject(I18nService);
  private el = inject(ElementRef);

  // Signals
  private scrollTop = signal<number>(GLOBAL_CONSTANT.DEFAULT_INITIALIZER);
  windowScrolled = computed(() => this.scrollTop() > GLOBAL_CONSTANT.WINDOW_SCROLL_MIN_HEIGHT);
  svg_icon_top = Icons.ARROW_TOP;

  // Track the actual scrolling container
  private scrollContainer: HTMLElement | null = null;

  // Effect to listen to scroll
  scrollEffect = effect(() => {
    const handler = (e: Event) => {
      const target = e.target as HTMLElement;
      if (target?.scrollTop !== undefined) {
        this.scrollContainer = target;
        this.scrollTop.set(target.scrollTop);
      }
    };

    window.addEventListener(GLOBAL_CONSTANT.EVENT_SCROLL, handler, true);

    // Cleanup on destroy
    return () => window.removeEventListener(GLOBAL_CONSTANT.EVENT_SCROLL, handler, true);
  });

  // Scroll to top method
  scrollToTop() {
    // Use the captured scroll container first, then fall back to known selectors
    const target =
      this.scrollContainer ||
      this.el.nativeElement.closest('.scrollable') ||
      document.getElementById('scrollContent') ||
      document.querySelector('[cdkScrollable]');

    if (target) {
      target.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }
}
